// eslint-disable-next-line no-restricted-imports
import { Image } from 'dripsy';

export default Image;
